"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = renderWebChat;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

function renderWebChat(ReactWebChat, props, element) {
  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(ReactWebChat, props), element);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9yZW5kZXJXZWJDaGF0LnRzeCJdLCJuYW1lcyI6WyJyZW5kZXJXZWJDaGF0IiwiUmVhY3RXZWJDaGF0IiwicHJvcHMiLCJlbGVtZW50IiwiUmVhY3RET00iLCJyZW5kZXIiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUVlLFNBQVNBLGFBQVQsQ0FBdUJDLFlBQXZCLEVBQXlEQyxLQUF6RCxFQUFxRUMsT0FBckUsRUFBaUc7QUFDOUdDLG9CQUFTQyxNQUFULGVBQWdCLDZCQUFDLFlBQUQsRUFBa0JILEtBQWxCLENBQWhCLEVBQTZDQyxPQUE3QztBQUNEIiwic291cmNlUm9vdCI6ImJ1bmRsZTovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgQ29tcG9uZW50VHlwZSB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBSZWFjdERPTSBmcm9tICdyZWFjdC1kb20nO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiByZW5kZXJXZWJDaGF0KFJlYWN0V2ViQ2hhdDogQ29tcG9uZW50VHlwZTxhbnk+LCBwcm9wczogYW55LCBlbGVtZW50OiBIVE1MRWxlbWVudCk6IHZvaWQge1xuICBSZWFjdERPTS5yZW5kZXIoPFJlYWN0V2ViQ2hhdCB7Li4ucHJvcHN9IC8+LCBlbGVtZW50KTtcbn1cbiJdfQ==